// → form component used for contact and enquiry page

import React, { useState, useContext } from "react";
import { navigate } from "gatsby";
import {
  mainBlue,
  mainGrey,
  mainWhite,
  mainOrange,
  lightGrey,
  transHover,
  emailRegex,
  screen,
} from "../common/variables";
import styled from "styled-components";
import Spinner from "../../images/svg/spinner.svg";
import emailjs from "emailjs-com";

import { StoreContext } from "../../context";

const Wrapper = styled.div`
  width: 100%;
  @media ${screen.small} {
    max-width: 800px;
  }

  .form-heading {
    color: ${mainGrey};
    display: block;
    font-size: 1.17rem;
    margin-bottom: 14px;
    @media ${screen.xsmall} {
      font-size: 1.3rem;
    }
    @media ${screen.xlarge} {
      font-size: 1.5rem;
    }
  }

  .form {
    background-color: ${props => (props.enquiry ? mainWhite : lightGrey)};
    padding: ${props => (props.enquiry ? `0` : `35px 35px 70px 35px`)};
    position: relative;
    @media ${screen.xsmall} {
      padding: ${props => (props.enquiry ? `0` : `60px 70px 110px 70px`)};
    }
    @media ${screen.xlarge} {
      padding: ${props => (props.enquiry ? `0` : `90px 90px 110px 90px`)};
    }

    .checkbox-row {
      display: block;

      &__options {
        display: flex;
        flex-direction: column;
        margin: 0 0 0 12px;
        @media ${screen.xsmall} {
          flex-direction: row;
          margin: 0 auto;
        }

        .each-option {
          margin: 7px 0;
          @media ${screen.xsmall} {
            width: 50%;
          }

          label {
            font-size: 1.05rem;
            font-weight: 300;
            vertical-align: middle;
            margin-left: 10px;
            @media ${screen.xsmall} {
              font-size: 1.2rem;
            }
          }
        }
      }

      &__heading {
        display: block;
        font-size: 1rem;
        font-weight: 300;
        margin-bottom: 10px;
        @media ${screen.xsmall} {
          font-size: 1.2rem;
        }
      }

      &__each-option {
        display: block;
        background: red;
      }
    }

    .input-row {
      display: block;
      width: 100%;

      input {
        border: 0;
        border-radius: 0;
        background-color: ${props => (props.enquiry ? mainWhite : lightGrey)};
        border-bottom: 1px ${mainBlue} solid;
        color: ${mainBlue};
        display: block;
        width: 100%;
        font-size: 1rem;
        font-weight: 500;
        outline: none;
        padding: 7px 0;
        @media ${screen.xsmall} {
          font-size: 1.1rem;
          padding: 10px 0;
        }
        @media ${screen.xlarge} {
          font-size: 1.2rem;
        }
      }

      textarea {
        border: 0;
        border-radius: 0;
        color: ${mainBlue};
        display: block;
        height: 110px;
        width: 100%;
        resize: none;
        padding: 12px;
        font-size: 1.05rem;
        font-weight: 500;
        outline-color: ${mainBlue};
        margin-top: 10px;
        border: ${props => (props.enquiry ? `1px ${mainBlue} solid` : `none`)};
        @media ${screen.xsmall} {
          font-size: 1.1rem;
          padding: 15px;
          height: 130px;
        }
        @media ${screen.xlarge} {
          font-size: 1.2rem;
          padding: 25px;
        }
        &::placeholder {
          color: ${mainBlue};
        }
      }

      .error-textarea {
        &::placeholder {
          color: ${mainOrange};
        }
      }

      label {
        font-size: 1rem;
        font-weight: 500;
        position: absolute;
        transform: translateY(10px);
        transition: ${transHover};
        pointer-events: none;
        color: ${mainBlue};
        @media ${screen.xsmall} {
          font-size: 1.2rem;
        }
      }

      .focused-label {
        transform: translateY(-10px);
        font-size: 0.87rem;
        font-weight: 300;
      }

      .error-label {
        color: ${mainOrange};
      }

      &--half {
        display: flex;
        flex-direction: column;
        width: 100%;
        @media ${screen.xsmall} {
          flex-direction: row;
          justify-content: space-between;
        }

        .input-row__each-input {
          width: 100%;
          @media ${screen.xsmall} {
            width: 47%;
          }
        }
      }

      &__each-input {
        display: block;
        padding: 9px 0;
        margin: 4px 0;
        width: 100%;
        position: relative;
        @media ${screen.xsmall} {
          margin: 10px 0;
        }
      }
    }

    button {
      background-color: ${mainGrey};
      color: ${mainWhite};
      border: 0;
      cursor: pointer;
      display: block;
      margin-top: 20px;
      font-size: 0.93rem;
      padding: 10px;
      width: 100%;
      transition: ${transHover};
      outline-color: ${mainBlue};
      @media ${screen.withCursor} {
        &:hover {
          background-color: ${mainOrange};
        }
      }
    }

    .spinner {
      width: 42px;
      height: 42px;
      position: absolute;
      left: 50%;
      bottom: ${props => (props.enquiry ? `-76px` : `16px`)};
      transform: translateX(-50%);
      @media ${screen.xsmall} {
        width: 62px;
        height: 62px;
        bottom: ${props => (props.enquiry ? `-76px` : `36px`)};
      }
    }

    .failed-text {
      color: ${mainOrange};
      position: absolute;
      left: 50%;
      bottom: 23px;
      font-size: 0.95rem;
      transform: translateX(-50%);
      @media ${screen.xsmall} {
        font-size: 1rem;
        bottom: 50px;
      }
    }
  }
`;

// → only used enquiry prop to know if component is on enquiry page, its only for css styling that conditionally use with styled-components library
// → form for contact and enquiry page slightly have different css style
const Form = ({ enquiry, orders }) => {
  // → setOrders function for emptying the product array if enquiry succesfully submitted
  const { setOrders } = useContext(StoreContext);

  // → user inputs
  const [inputs, setInputs] = useState({
    insterestThermic: false,
    interestFoundry: false,
    company: "",
    firstName: "",
    lastName: "",
    address: "",
    postCode: "",
    city: "",
    phone: "",
    email: "",
    message: "",
  });

  // → detect fields if on focus. for styling purposes
  const [focus, setFocus] = useState({
    company: false,
    firstName: false,
    lastName: false,
    address: false,
    postCode: false,
    city: false,
    phone: false,
    email: false,
  });

  // → feedback states for user inputs
  const [isFirstNameValid, setFirstNameValid] = useState(false);
  const [isLastNameValid, setLastNameValid] = useState(false);
  const [isCompanyValid, setCompanyValid] = useState(false);
  const [isAddressValid, setAddressValid] = useState(false);
  const [isPhoneValid, setPhoneValid] = useState(false);
  const [isEmailValid, setEmailValid] = useState(false);
  const [isMessageValid, setMessageValid] = useState(false);
  const [isSending, setSending] = useState(false);
  const [isFailed, setFailed] = useState(false);

  // → user input handler
  const handleInput = e => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    });
  };

  // → for adding style for label if user focus on input element
  const handleFocus = e => {
    setFocus({
      ...focus,
      [e.target.name]: true,
    });
    if (isFailed) {
      setFailed(false);
    }
  };

  // → for removing style for label if user unfocus the input element
  const handleBlur = e => {
    if (!inputs[e.target.name].length) {
      setFocus({
        ...focus,
        [e.target.name]: false,
      });
    }
  };

  // → submit form handler
  const handleSubmit = e => {
    e.preventDefault();

    // → validate inputs for front end display
    validateInputs();

    // → if all inputs are valid do this
    if (shouldSend()) {
      // → template to send to EmailJS
      const templateContact = {
        subject: `From ${inputs.firstName} - Website ${
          enquiry ? `Enquiry` : `Contact`
        } Submission`,
        email: inputs.email,
        my_html: `
        <p><strong>Interest: </strong></p>
        <ul>
        ${
          orders
            ? orders
                .map(
                  order =>
                    `<li><p>${order.name} - ${order.code} - quantity(<strong>${order.quantity}</strong>)</p></li>`
                )
                .join("")
            : `<li><p>${getInterestMsg()}</p></li>`
        }
        </ul>
        <p><strong>Name: </strong>${inputs.firstName} ${inputs.lastName}</p>
        <p><strong>Email: </strong>${inputs.email}</p>
        <p><strong>Phone: </strong>${inputs.phone}</p>
        <p><strong>Company: </strong>${inputs.company}</p>
        <p><strong>Address: </strong>${inputs.address}</p>
        <p><strong>Postcode: </strong>${
          inputs.postCode ? inputs.postCode : `did not provide`
        }</p>
        <p><strong>City: </strong>${
          inputs.city ? inputs.city : `did not provide`
        }</p>
        <p><strong>Message: </strong>${inputs.message}</p>
      `,
      };

      // → show spinner while sending
      setSending(true);

      // → external email service for sending email with just client side code
      // → visit EmailJS website to learn more
      emailjs
        .send("gmail", "enquiry", templateContact, "user_fjJoLGqBncGJJpBqDlsFi")
        .then(
          response => {
            if (response.status === 200) {
              resetInputs();
              setSending(false);
              // → unFocusAll();
              if (enquiry) {
                navigate("/thank-you");
                setOrders([]);
              } else {
                navigate("/thank-you");
              }

              if (isFailed) {
                setFailed(false);
              }
            }
          },
          err => {
            setFailed(true);
            setSending(false);
          }
        );
    }
  };

  // → reset all input values
  const resetInputs = () => {
    setInputs({
      insterestThermic: false,
      interestFoundry: false,
      company: "",
      firstName: "",
      lastName: "",
      address: "",
      postCode: "",
      city: "",
      phone: "",
      email: "",
      message: "",
    });
  };

  // → must return true to finally submit email
  const shouldSend = () => {
    if (
      inputs.firstName.length &&
      inputs.lastName.length &&
      inputs.company.length &&
      inputs.address.length &&
      inputs.phone.length &&
      inputs.message.length &&
      emailRegex.test(inputs.email)
    ) {
      return true;
    } else {
      return false;
    }
  };

  // → simple client side input validation
  const validateInputs = () => {
    if (!inputs.firstName.length) {
      setFirstNameValid(true);
    } else {
      setFirstNameValid(false);
    }
    if (!inputs.lastName.length) {
      setLastNameValid(true);
    } else {
      setLastNameValid(false);
    }
    if (!inputs.company.length) {
      setCompanyValid(true);
    } else {
      setCompanyValid(false);
    }
    if (!inputs.address.length) {
      setAddressValid(true);
    } else {
      setAddressValid(false);
    }
    if (!inputs.phone.length) {
      setPhoneValid(true);
    } else {
      setPhoneValid(false);
    }
    if (!inputs.message.length) {
      setMessageValid(true);
    } else {
      setMessageValid(false);
    }
    if (!emailRegex.test(inputs.email)) {
      setEmailValid(true);
      setFocus({
        ...focus,
        email: false,
      });
      setInputs({
        ...inputs,
        email: "",
      });
    } else {
      setEmailValid(false);
    }
  };

  // → conditional interest body to send
  const getInterestMsg = () => {
    if (inputs.insterestThermic && inputs.interestFoundry) {
      return "Thermic Lance Products and Foundry Products";
    } else if (inputs.insterestThermic) {
      return "Thermic Lance Products";
    } else if (inputs.interestFoundry) {
      return "Foundry Products";
    } else {
      return "did not provide";
    }
  };

  return (
    <Wrapper enquiry={enquiry}>
      {enquiry && <h5 className="form-heading">YOUR DETAILS</h5>}
      <form onSubmit={handleSubmit} className="form" autoComplete="off">
        {!enquiry && (
          <span className="checkbox-row">
            <label className="checkbox-row__heading">I’m interested in</label>
            <span className="checkbox-row__options">
              <span className="each-option">
                <input
                  onChange={e => {
                    setInputs({
                      ...inputs,
                      insterestThermic: e.target.checked,
                    });
                  }}
                  type="checkbox"
                  id="lance"
                  value="Thermic Lance Products"
                />
                <label htmlFor="lance">Thermic Lance Products</label>
              </span>
              <span className="each-option">
                <input
                  onChange={e => {
                    setInputs({
                      ...inputs,
                      interestFoundry: e.target.checked,
                    });
                  }}
                  type="checkbox"
                  id="foundry"
                  value="Foundry Products"
                />
                <label htmlFor="foundry">Foundry Products</label>
              </span>
            </span>
          </span>
        )}

        {enquiry && (
          <span className="input-row input-row--half">
            <span className="input-row__each-input">
              <label
                className={
                  focus.firstName
                    ? `focused-label`
                    : isFirstNameValid
                    ? `error-label`
                    : null
                }
              >
                First Name*
              </label>
              <input
                onChange={handleInput}
                onBlur={handleBlur}
                onFocus={handleFocus}
                value={inputs.firstName}
                type="text"
                name="firstName"
              />
            </span>

            <span className="input-row__each-input">
              <label
                className={
                  focus.lastName
                    ? `focused-label`
                    : isLastNameValid
                    ? `error-label`
                    : null
                }
              >
                Last Name*
              </label>
              <input
                onChange={handleInput}
                onBlur={handleBlur}
                onFocus={handleFocus}
                value={inputs.lastName}
                type="text"
                name="lastName"
              />
            </span>
          </span>
        )}

        <span className="input-row">
          <span className="input-row__each-input">
            <label
              className={
                focus.company
                  ? `focused-label`
                  : isCompanyValid
                  ? `error-label`
                  : null
              }
            >
              Company*
            </label>
            <input
              onChange={handleInput}
              onBlur={handleBlur}
              onFocus={handleFocus}
              value={inputs.company}
              type="text"
              name="company"
            />
          </span>
        </span>
        {!enquiry && (
          <span className="input-row input-row--half">
            <span className="input-row__each-input">
              <label
                className={
                  focus.firstName
                    ? `focused-label`
                    : isFirstNameValid
                    ? `error-label`
                    : null
                }
              >
                First Name*
              </label>
              <input
                onChange={handleInput}
                onBlur={handleBlur}
                onFocus={handleFocus}
                value={inputs.firstName}
                type="text"
                name="firstName"
              />
            </span>

            <span className="input-row__each-input">
              <label
                className={
                  focus.lastName
                    ? `focused-label`
                    : isLastNameValid
                    ? `error-label`
                    : null
                }
              >
                Last Name*
              </label>
              <input
                onChange={handleInput}
                onBlur={handleBlur}
                onFocus={handleFocus}
                value={inputs.lastName}
                type="text"
                name="lastName"
              />
            </span>
          </span>
        )}
        <span className="input-row">
          <span className="input-row__each-input">
            <label
              className={
                focus.address
                  ? `focused-label`
                  : isAddressValid
                  ? `error-label`
                  : null
              }
            >
              Address*
            </label>
            <input
              onChange={handleInput}
              onBlur={handleBlur}
              onFocus={handleFocus}
              value={inputs.address}
              type="text"
              name="address"
            />
          </span>
        </span>
        <span className="input-row input-row--half">
          <span className="input-row__each-input">
            <label className={focus.postCode ? `focused-label` : null}>
              Postcode
            </label>
            <input
              onChange={handleInput}
              onBlur={handleBlur}
              onFocus={handleFocus}
              value={inputs.postCode}
              type="text"
              name="postCode"
            />
          </span>

          <span className="input-row__each-input">
            <label className={focus.city ? `focused-label` : null}>City</label>
            <input
              onChange={handleInput}
              onBlur={handleBlur}
              onFocus={handleFocus}
              value={inputs.city}
              type="text"
              name="city"
            />
          </span>
        </span>
        <span className="input-row input-row--half">
          <span className="input-row__each-input">
            <label
              className={
                focus.phone
                  ? `focused-label`
                  : isPhoneValid
                  ? `error-label`
                  : null
              }
            >
              Contact Number*
            </label>
            <input
              onChange={handleInput}
              onBlur={handleBlur}
              onFocus={handleFocus}
              value={inputs.phone}
              type="text"
              name="phone"
            />
          </span>

          <span className="input-row__each-input">
            <label
              className={
                focus.email
                  ? `focused-label`
                  : isEmailValid
                  ? `error-label`
                  : null
              }
            >
              Email Address*
            </label>
            <input
              onChange={handleInput}
              onBlur={handleBlur}
              onFocus={handleFocus}
              value={inputs.email}
              type="text"
              name="email"
            />
          </span>
        </span>
        <span className="input-row">
          <textarea
            onChange={handleInput}
            value={inputs.message}
            name="message"
            placeholder="Tell us about your enquiry."
            className={isMessageValid ? `error-textarea` : null}
          ></textarea>
        </span>
        <button>SUBMIT</button>

        {isSending && <Spinner className="spinner" />}

        {isFailed && (
          <span className="failed-text">
            Something went wrong.. please try again
          </span>
        )}
      </form>
    </Wrapper>
  );
};

export default Form;
